<fa-icon class="pointer uk-margin-small-left" (click)="openFile()" [icon]="['far', 'eye']"></fa-icon>

<fa-icon class="pointer uk-margin-small-left" (click)="downloadFile()" icon="download"></fa-icon>

<ng-template appModalHost></ng-template>
